import { render, staticRenderFns } from "./kuranGoodsFullwidthItem.vue?vue&type=template&id=dec792a6"
import script from "./kuranGoodsFullwidthItem.vue?vue&type=script&lang=js"
export * from "./kuranGoodsFullwidthItem.vue?vue&type=script&lang=js"
import style0 from "./kuranGoodsFullwidthItem.vue?vue&type=style&index=0&id=dec792a6&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports